<div
  (click)="toggleEditable()"
  class="field-mapping-header"
  layout
  layout-space-between
  layout-align-items-center
>
  <div layout layout-vertical>
    <span class="field-mapping-label">
      @for (label of formInput().label; track trackByIndex($index); let isFirst = $first) {
        @if (!isFirst) {
          <rt-divider variant="dot light" />
        }
        <span>
          {{ buildText(label) }}
        </span>
      }
    </span>

    <div layout layout-align-items-center>
      <span text-light margin-right-small-xx>
        {{
          'rti.field_mapping.settings.x_field_mappings'
            | translate: { count: formInput().fieldMappings.length }
        }}</span
      >
    </div>
  </div>
  <div class="trigger-icon">
    <rt-icon name="keyboard-arrow-down" [class.active]="editable" />
  </div>
</div>

@if (editable) {
  <div
    class="field-mapping-editable"
    (cdkDropListDropped)="onDrop($event)"
    cdkDropList
    cdkDropListLockAxis="y"
  >
    <div class="field-mapping-list">
      @for (
        fieldMapping of formInput().fieldMappings;
        track trackById($index, fieldMapping);
        let itemsCount = $count;
        let isFirst = $first
      ) {
        <div margin-tb-small-x class="field-mapping-list-item">
          @if (showIfElseLabel(itemsCount, isFirst)) {
            <div class="field-mapping-between-label">
              {{ ifElseLabel }}
            </div>
          }

          <rti-field-mapping-form-field-mapping
            cdkDrag
            cdkDragBoundary=".field-mapping-editable"
            [fieldMapping]="fieldMapping"
            [integrationKind]="integrationKind()"
            (fieldMappingDeleted)="handleFieldMappingDeletion($event)"
          />
        </div>
      }
    </div>
  </div>

  <div margin-bottom>
    <rt-add-new-button
      (click)="openDialog()"
      [text]="'rti.field_mapping.settings.add.button' | translate"
      variant="wide"
    />
  </div>
}
